import { gql } from '@apollo/client';

export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserRequest!) {
    createUser(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        created
        modified
        deleted
        first_name
        last_name
        email
        phone
        super_admin
        groups
        type
        last_accessed
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserRequest!) {
    updateUser(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        created
        modified
        deleted
        first_name
        last_name
        email
        phone
        super_admin
        groups
        type
        last_accessed
      }
    }
  }
`;

export const SOFT_DELETE_USER = gql`
  mutation SoftDeleteUser($input: SoftDeleteUserRequest!) {
    softDeleteUser(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const RESTORE_USER = gql`
  mutation RestoreUser($input: RestoreUserRequest!) {
    restoreUser(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const UPDATE_USER_LAST_ACCESSED = gql`
  mutation UpdateUserLastAccessed($input: UpdateUserRequest!) {
    updateUserLastAccessed(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result
    }
  }
`;

const BULK_ENVELOPE_BODY = `
  metadata {
    status
    errors
    tracking_id
  }
  result {
    successes {
      id
      first_name
      last_name
      email
      deleted
      groups
    }
    failures {
      id
      error
    }
    skipped {
      id
      reason
    }
  }
`;

export const SOFT_DELETE_USERS = gql`
  mutation SoftDeleteUsers($input: SoftDeleteUsersRequest!) {
    softDeleteUsers(input: $input) {
      ${BULK_ENVELOPE_BODY}
    }
  }
`;

export const RESTORE_USERS = gql`
  mutation RestoreUsers($input: RestoreUsersRequest!) {
    restoreUsers(input: $input) {
      ${BULK_ENVELOPE_BODY}
    }
  }
`;

export const UPDATE_USERS_ACCESS = gql`
  mutation UpdateUsersAccess($input: UpdateUsersAccessRequest!) {
    updateUsersAccess(input: $input) {
      ${BULK_ENVELOPE_BODY}
    }
  }
`;

export const CREATE_USERS = gql`
  mutation CreateUsers($input: CreateUsersRequest!) {
    createUsers(input: $input) {
      ${BULK_ENVELOPE_BODY}
    }
  }
`;
